import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { Row } from '../Scaffold';
import Progress from '../../Progress';
import { renderField } from '../../Inputs';
import { updatePathway } from '../../../Actions/Password/register';


class AllResults extends React.PureComponent {
  componentWillMount() {
    this.togglePathway = this.togglePathway.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);

    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }

    this.props.handleSubmit();
    this.setState({ submitted: true });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  togglePathway(data) {
    this.props.dispatch(updatePathway(data));
  }

  render() {
    const {
      handleSubmit, smoking, smokingamount, pregnant, ethnicity,
    } = this.props;


    let smokeTitle = '';
    let smokeStrap = '';
    let smokeBody = [];

    switch (ethnicity) {
      case 'Asian or Asian British - Any other Asian background':
      case 'Asian or Asian British - Bangladeshi':
      case 'Asian or Asian British - Indian':
      case 'Asian or Asian British - Pakistani':
      case 'Other Ethnic Groups - Chinese':
        break;
      default:
        break;
    }

    // PREGNANT
    if (pregnant === 'Yes') {
      // SMOKING + PREGNANT
      if (smoking === 'No') {
        smokeTitle = 'Congratulations on being smoke free!';
        smokeStrap = 'You\'re doing great!';
        smokeBody = [
          <Paragraph classes="width-limited" key="id-1" center>Being a non-smoker is one of the best things you can do for your health, your baby and your bank balance. Good work!</Paragraph>,
        ];
      } else {
        smokeTitle = 'Stopping smoking is the best thing you can do for you and your baby.';
        smokeStrap = 'We can help.';
        smokeBody = [
          <Paragraph classes="width-limited" key="id-1" center>
            It is up to you to decide when {"you're"} ready and how to quit. Smoking can greatly increase your chances of having a heart at stroke. Your risk of lung disease, coronary heart disease, and other problems including are much higher.
          </Paragraph>,
          <Paragraph classes="width-limited" key="id-2" center>
            We are here to help you whenever you feel ready to start thinking about it.
          </Paragraph>,
        ];
      }
    }

    // SMOKING + NOT PREGNANT
    if (smoking === 'No') {
      smokeTitle = 'Congratulations on being smoke free!';
      smokeStrap = 'You\'re doing great!';
      smokeBody = [
        <Paragraph classes="width-limited" key="id-1" center>
          Being a non-smoker is one of the best things you can do for your health, your family and your bank balance. Good work!
        </Paragraph>,
      ];
    } else {
      smokeTitle = "Just remember we're here for you!";
      smokeStrap = 'We can help.';
      smokeBody = [
        <Paragraph classes="width-limited" key="id-1" center>
          It is up to you to decide when {"you're"} ready and how to quit. Smoking can greatly increase your chances of having a heart attack or stroke. Your risk of lung disease, coronary heart disease, and other problems including cancer are much higher.
        </Paragraph>,
        <Paragraph classes="width-limited" key="id-2" center>
          We are here to help you whenever you feel ready to start thinking about it.
        </Paragraph>,
      ];
    }

    let amount = smokingamount;
    if (this.props.smoking === 'No') {
      amount = '0';
    }

    let smokeType = '';
    if (this.props.smokingtype === '1517') {
      smokeType = 'Cigarettes';
    } else if (this.props.smokingtype === '1518') {
      smokeType = 'Cigars';
    } else if (this.props.smokingtype === '1617') {
      smokeType = 'Non-smoker';
    } else if (this.props.smokingtype === '1520') {
      smokeType = 'Pipe';
    } else if (this.props.smokingtype === '1521') {
      smokeType = 'Roll-ups';
    } else if (this.props.smokingtype === '1519') {
      smokeType = 'e-Cigarettes';
    }

    return (
      <Row classes="all-results" setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <Progress step="all" />
        <Heading classes="header-text purple" center><div id="registerComplete">Congratulations!</div></Heading>
        <Paragraph classes="header-desc" center>You are now registered with LiveWell Dorset.</Paragraph>
        <Paragraph classes="width-limited" center>
        One of our Wellness Coaches will be in touch within two working days to arrange your first appointment. You'll also receive an email from us confirming your registration and inviting you to log into your healthy living profile online.
        </Paragraph>
        <Paragraph classes="result-text" center>My Results</Paragraph>
        <form onSubmit={handleSubmit} className="form-register">
          <div className="single-item">
            <Paragraph classes="item-title" center>Smoking</Paragraph>
            <Paragraph classes="item-logo" center>
              <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="100" height="100" />
            </Paragraph>
            <Row classes="item-times-unit">
              <Paragraph classes="item-times" center>{amount}</Paragraph>
              <Paragraph classes="item-unit" center>{smokeType} per day</Paragraph>
            </Row>
            <Paragraph classes="item-comment width-limited" center>{smokeStrap}</Paragraph>
          </div>
          <Heading classes="content-title" center>{smokeTitle}</Heading>
          {smokeBody}

          <div className="button-groups divideline">
            <Button classes={['color-button']} label="Go to profile" onClick={this.props.dashboard} />
            {/* <Button classes={['underline-button']} label="Back" onClick={this.props.previousPage} /> */}
          </div>
        </form>
      </Row>
    );
  }
}

AllResults.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  // previousPage: PropTypes.func.isRequired,
  smoking: PropTypes.string.isRequired,
  pregnant: PropTypes.string.isRequired,
  dashboard: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registrationPilot', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AllResults);



// WEBPACK FOOTER //
// ./src/Components/PilotRegister/FormPages/AllResults.jsx